/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this useful for cheques?`)
};

const es_nw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Esto es útil para cheques?`)
};

const de_nw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist das für Schecks nützlich?`)
};

const nl_nw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is dit handig voor cheques?`)
};

const fr_nw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est-ce utile pour les chèques ?`)
};

const it_nw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È utile per gli assegni?`)
};

const pt_br2_nw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso é útil para cheques?`)
};

const pt_nw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isto é útil para cheques?`)
};

const ja_nw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小切手に役立ちますか？`)
};

const zh_nw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这对支票有用吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_faq3_q", locale)
	if (locale === "en") return en_nw_faq3_q(inputs)
	if (locale === "es") return es_nw_faq3_q(inputs)
	if (locale === "de") return de_nw_faq3_q(inputs)
	if (locale === "nl") return nl_nw_faq3_q(inputs)
	if (locale === "fr") return fr_nw_faq3_q(inputs)
	if (locale === "it") return it_nw_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_nw_faq3_q(inputs)
	if (locale === "pt") return pt_nw_faq3_q(inputs)
	if (locale === "ja") return ja_nw_faq3_q(inputs)
	return zh_nw_faq3_q(inputs)
};